
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M74.25 50.483L24 21.472v58.023l50.25-29.012zm6.5 4.33c3.333-1.924 3.333-6.735 0-8.66L24.5 13.677c-3.333-1.924-7.5.482-7.5 4.33V82.96c0 3.85 4.167 6.255 7.5 4.33l56.25-32.476z","fill":"#e5b409"}})])
          )
        }
      }
    